import {
  utils,
  conditions,
} from '@xing-com/platform-layout-common-meta-renderer-resolvers';

export const commonResolvers = { ...utils, ...conditions };
